import { AppError } from 'components/AppError';
import { MghRoute } from 'components/MghRoute';
import { MainLayout } from 'layouts/MainLayout';
import { About } from 'pages/About';
import { Account } from 'pages/Account';
import { AccountVerification } from 'pages/AccountVerification';
import { EmailChange } from 'pages/EmailChange';
import { Energy } from 'pages/Energy';
import { Eula } from 'pages/Eula';
import { ForgottenPassword } from 'pages/ForgottenPassword';
import { HomeSettings } from 'pages/HomeSettings';
import { Light } from 'pages/Light';
import { Login } from 'pages/Login/Login';
import { MainLights } from 'pages/MainLights';
import { PresetDetails } from 'pages/PresetDetails';
import { Registration } from 'pages/Registration';
import { ResetPassword } from 'pages/ResetPassword';
import { Room } from 'pages/Room';
import { Sensors } from 'pages/Sensors';
import { Shades } from 'pages/Shades';
import { SupportTicket } from 'pages/SupportTicket';
import { Temperature } from 'pages/Temperature';
import { AwayPage } from 'pages/Temperature/Away';
import { SchedulePage } from 'pages/Temperature/Schedule';
import { ThermostatPage } from 'pages/Temperature/Thermostat';
import { VerifyEmailChange } from 'pages/VerifyEmailChange';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { BaseLayout } from './layouts/BaseLayout';
import { Home } from './pages/Home';
import { DataConsent } from 'pages/DataConsent';

export const router = createBrowserRouter(
  [
    {
      element: <BaseLayout />,
      children: [
        {
          element: <MainLayout />,
          errorElement: <AppError />,
          children: [
            {
              path: '/',
              element: (
                <MghRoute>
                  <Navigate to="/home" />
                </MghRoute>
              ),
            },
            {
              path: 'home',
              element: (
                <MghRoute>
                  <Home />
                </MghRoute>
              ),
            },
            {
              path: 'home-settings',
              element: (
                <MghRoute>
                  <HomeSettings />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId',
              element: (
                <MghRoute>
                  <Room />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId/lighting/:lightId',
              element: (
                <MghRoute>
                  <Light />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId/lights-group/:groupId',
              element: (
                <MghRoute>
                  <MainLights />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId/lights-group/:groupId/preset/:presetId',
              element: (
                <MghRoute>
                  <PresetDetails />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId/sensors/:sensorsId',
              element: (
                <MghRoute>
                  <Sensors />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId/shades/:parentShadesId',
              element: (
                <MghRoute>
                  <Shades />
                </MghRoute>
              ),
            },
            {
              path: 'room/:roomId/temperature/:temperatureThingId',
              element: (
                <MghRoute>
                  <Temperature />
                </MghRoute>
              ),
              children: [
                {
                  path: 'thermostat',
                  element: <ThermostatPage />,
                },
                {
                  path: 'schedule',
                  element: <SchedulePage />,
                },
                {
                  path: 'away',
                  element: <AwayPage />,
                },
              ],
            },
            {
              path: 'energy',
              element: (
                <MghRoute>
                  <Energy />
                </MghRoute>
              ),
            },
            {
              path: 'account',
              element: (
                <MghRoute>
                  <Account />
                </MghRoute>
              ),
            },
            {
              path: 'account/about',
              element: (
                <MghRoute>
                  <About />
                </MghRoute>
              ),
            },
            {
              path: 'account/eula',
              element: (
                <MghRoute>
                  <Eula />
                </MghRoute>
              ),
            },
            {
              path: 'account/support/createTicket/:id',
              element: (
                <MghRoute>
                  <SupportTicket />
                </MghRoute>
              ),
            },
            {
              path: 'account/email',
              element: (
                <MghRoute>
                  <EmailChange />
                </MghRoute>
              ),
            },
            {
              path: 'account/email/verify',
              element: (
                <MghRoute>
                  <VerifyEmailChange />
                </MghRoute>
              ),
            },
            {
              path: 'account/consent',
              element: (
                <MghRoute ignoreDataConsent>
                  <DataConsent navigationButtons />
                </MghRoute>
              ),
            },
            {
              path: 'consent',
              element: (
                <MghRoute ignoreDataConsent>
                  <DataConsent />
                </MghRoute>
              ),
            },
            { path: 'register', element: <Registration /> },
            { path: 'verify-account', element: <AccountVerification /> },
            { path: 'forgot-password', element: <ForgottenPassword /> },
            { path: 'reset-password/:email', element: <ResetPassword /> },
          ],
        },
        { path: 'login', element: <Login /> },
      ],
    },
  ],
  {
    basename: import.meta.env.VITE_PUBLIC_URL,
  },
);
